























import { Component, Vue, Mixins } from "vue-property-decorator";
// 组件
import Dialog from "./components/Dialog.vue";
import List from "./components/List.vue";
// api
import { getCarousel, deleteCarouselItem } from "@/api/system";
import { Carousel } from "@/types/api/system";
// 工具
import copy from "@/utils/deepCopy";
import Loading from "@/mixins/loading";

@Component({
  components: {
    Dialog,
    List,
  },
})
export default class CarouselComponent extends Mixins(Loading) {
  dialogVisible: boolean = false;
  type: string = "add"; // add:添加 edit:编辑
  // 初始化表单
  initForm: Carousel = {
    img: "",
    linkContent: "",
    linkType: 0,
    subtitle: "",
    title: "",
    type: 1,
    id: 0,
  };
  form: Carousel = this.initForm;
  dialogVisibleImg: boolean = false;
  imgUrl: string = "";

  // 添加
  handleAdd() {
    this.type = "add";
    this.form = copy(this.initForm);
    this.dialogVisible = true;
  }
  // 修改
  handleEdit(item: Carousel) {
    this.type = "edit";
    this.form = copy(item);
    this.dialogVisible = true;
  }
  // 查看图片
  previewImg(url: string) {
    this.dialogVisibleImg = true;
    this.imgUrl = url;
  }
  // 刷新列表数据
  getData() {
    let list: any = this.$refs.list;
    list.getCarouselList();
  }
}
